export default __webpack_public_path__ + "static/media/smile-2.96a87dd1.svg";